/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    export interface IGridConfiguration {
        defaultSorts?   : any;
        defaultFilters  : any;
        externalFilters?: any;
        columnMap       : any;
        columns         : any;
    }

    export interface ICollectionConfiguration {
        model            : any;
        loadMethod       : string;
    }

    export interface ICsvConfiguration {
        showExporterMenu?   : boolean;
        allPages?           : any;
        thisPage?           : any;
        sort?               : any;
    }

    export interface IPagerConfiguration {
        transitionStart?    : any;
        transitionSuccess?  : any;
        transitionError?    : any;
        pageSizes?          : any[]
    }

    export interface IReportsConfiguration {
        grid        : IGridConfiguration;
        collection  : ICollectionConfiguration;
        csvExport?  : ICsvConfiguration;
        pager?      : IPagerConfiguration;

        propertiesToApiMap? : any;
        $scope             : ng.IScope;
    }

    export enum Languages {
        French = 'fr',
        English = 'en'
    }



    export interface IReportsControllerScope extends ng.IScope {
        timeRemaining       : string;
        showTimeRemaining   : boolean;
    }

    export class ReportsController {

        public static $inject : string[ ] = [
            '$q',
            '$scope',
            '$mdDialog',
            '$timeout',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'DataUtils',
            '$mobilityCompanyAuthentication',
            'thisReportConfiguration',
            'uiGridConstants'
        ];

        private static get DOWNLOAD_CSV_STATUSES () : any {
            return {
                NONE:           'None',
                IN_PROGRESS:    'Downloading...',
                FINISHED:       'Download Complete',
                ERROR_DOWNLOAD: 'Download Error'
            }
        }


        private locationId                  : number = -1;
        private locationName                : string;
        private timeZone                    : string;
        private timeZoneCode                : string;

        private dataUtils                   : any;
        private debouncing                  : boolean = false;
        private loadRequested               : boolean = false;

        private collapsed                   : boolean = false;
        private loading                     : boolean = false;
        private error                       : boolean = false;

        private serverSidePageSortFilter    : boolean = false;
        private enableFiltering             : boolean = false;
        private filterControlData           : any = { };

        private propertiesToApiMap          : any = { };

        private gridMap                     : any = { };
        private gridSorts                   : any = { };
        private gridFilters                 : any = { };
        private externalGridFilters         : string[] = [ ];
        private gridColumnDefs              : any[];

        private collection                  : any[] = [ ];

        private downloadCsvStatus           : string = 'NONE';
        private downloadCsvData             : any = { };
        private downloadCsvDataToast        : any;

        constructor(
            private $q                      : ng.IQService,
            private $scope                  : IReportsControllerScope,
            private $mdDialog               : any,
            private $timeout                : any,
            private $dealerwareLoading      : any,
            private $dealerwareNotification : any,
            private DataUtils               : any,
            private $auth                   : any,
            private thisReport              : IReportsConfiguration,
            private uiGridConstants         : any
        ) {

            var that = this;

            this.dataUtils = this.DataUtils.getInstance();

            this.gridSorts = angular.copy(this.thisReport.grid.defaultSorts);

            this.gridFilters = angular.copy(this.thisReport.grid.defaultFilters);

            this.createGridFieldsToApiMap();
            this.initializeCurrentUploadData();

            this.loading = true;

            var loader = this.$dealerwareLoading.show('Loading...');

            this.$timeout(() => {
                that.serverSidePageSortFilter = true;
                that.enableFiltering = true;
                that.gridMap = that.thisReport.grid.columnMap;

                // Columns need to be removed entirely sometimes so that they
                // don't show up in the grid hamburger menu either.  Since this isn't
                // a built-in grid function, this resolution only happens by a callback function
                // specified in the grid column definitions.
                //
                this.resolveAbsentColumns();

                // Some columns' visibility states need to be calculated, instead of being
                // a static boolean acted on by the grid code, after initial load asynchrony,
                // e.g. Current Location,
                // has been resolved.
                //
                this.resolveHiddenColumns();

                that.gridColumnDefs = [ ];
                that.thisReport.grid.columns.forEach( ( item: any ) => {
                    that.gridColumnDefs.push(item);
                });

                that.setLocation (this.$auth.location);
                that.setTimeZone (this.$auth.location);

                loader.close();
                that.loadData ();
            });

            this.thisReport.pager = this.thisReport.pager || { };
            this.thisReport.pager.transitionStart = ( ) => {
                return that.toggleResultsLoading();
            }
        }

        private setLocation (location: any) : void {
            this.locationId = location && location.id;
            this.locationName = location && location.name
        }

        private setTimeZone (location: any) : void {

            // formatTimeSimple assums UTC if a timeZone isn't given, but make it explicit here.
            //
            this.timeZone = location.time_zone_name || 'UTC';
            this.timeZoneCode = moment().tz(this.timeZone).format('z');
        }

        private initializeCurrentUploadData () : void {

            this.downloadCsvData = {

                processedRecords: ( ) => {
                    return this.downloadCsvData.stats.processed.itemCount;
                },

                stats  : {
                    total: {
                        label: 'Total',
                        itemCount: 0
                    },
                    processed: {
                        itemCount: 0
                    }
                }
            };
        }

        private toggleCollapsed() : void {
            this.collapsed = ! this.collapsed;
        }

        private createGridFieldsToApiMap ( ) : void {

            var that = this;

            Object.keys (this.thisReport.grid.columnMap)
                .forEach ( ( field: string ) => {
                        that.propertiesToApiMap [ that.thisReport.grid.columnMap[field] ] = field;
                        that.propertiesToApiMap [ that.thisReport.grid.columnMap[field] + '_display' ] = field;
                    }
                );
        }

        private get downloadCsvStatuses () : any {
            return ReportsController.DOWNLOAD_CSV_STATUSES;
        }

        private statusText () : string {
            return this.downloadCsvStatus === null ? '' : this.downloadCsvStatuses[this.downloadCsvStatus];
        }

        private setSort ( sortColumns: any[] ) : void {

            var that = this;

            // Given sort columns: calculate gridSorts.
            //
            // Given null for sortColumns: this is a signal to leave them alone (comes from filter onCall:
            // don't change what's there already).
            //
            // Given an empty array for sortColumns: this is a signal to blow away what's there.
            //
            if (sortColumns !== null) {

                if (sortColumns.length) {

                    var mappedField = sortColumns[0].field.replace(/_display$/, '');

                    // Accept a variety of mapping formats.  None, string, or object.
                    //
                    var mapConfig = that.propertiesToApiMap && that.propertiesToApiMap[mappedField];
                    if (mapConfig) {
                        if (angular.isString(mapConfig)) {
                            mappedField = mapConfig;
                        }
                        else if (angular.isObject(mapConfig)) {
                            mappedField = mapConfig.sort;
                        }
                    }

                    this.gridSorts = {
                        last_sort_by    : mappedField,
                        sort_by         : mappedField,
                        sort_direction  : sortColumns[0].sort.direction
                    };
                }
                else {
                    this.gridSorts = angular.copy(this.thisReport.grid.defaultSorts);
                }
            }
        }

        private setFilters ( filters: any ) : void {

            var that = this;

            // Remove from last/existing set of filters all of them (if _deleteAll is setl, such
            // as a pristine grid reload or filter clearing), or individual filters(s) whose
            // values are set to null as an assertion that they're not to be used, or all filters
            // but those given are to be deleted (_deleteAllOthers).  Or, there are filters that are
            // to be treated, temporarily at least, as fully external to the grid., and not subject
            // to removal.
            //
            Object.keys(this.gridFilters).forEach(( key: string) => {

                var gridKey = that.gridMap[key] || key;
                var apiKey  = that.propertiesToApiMap[key] || key;

                // Delete this pre-existing filter if:
                //
                //     1. All filters are being deleted on a clear (_deleteAll)
                //        OR
                //     2. This filter value is null;
                //        OR
                //     3. All filters *except* this field are to be deleted (_deleteAllOthers);
                //        AND
                //     4. Field is marked as being handled by grid or reports code
                //        (externalGridFilters).
                //
                // The filter key depends on whether the grid field name is the same as
                // the api field, or mapped.
                //
                var deleteField = ( filters._deleteAll
                    || filters[gridKey] === null
                    || filters[apiKey] === null
                    || ( filters._deleteAllOthers
                        && (filters[apiKey] === undefined || filters[apiKey] === undefined)
                    )
                ) && this.externalGridFilters.indexOf(apiKey) === -1;

                if (deleteField) {
                    delete that.gridFilters[apiKey];
                    if (filters !== null) {
                        delete filters[gridKey];
                        delete filters[apiKey];
                    }
                }
            });

            // Finish processing filters now that gridFilters has been sanitized of its deletions.
            //
            $.each(Object.keys(filters || { }),( i: number, key: string ) => {

                // Filter meta-commands don't count as real filters.
                //
                if (key.match(/^_/)) {
                    return true;
                }

                // Clearing a filter that wasn't already an Apply'ed filter -- which shouldn't
                // be allowed by the UI because the Clear button in the filter modal should be
                // disabled in that case -- needs to be zapped here in the absence of the fixes
                // in DCF-3317.
                //
                // DCF-3317 is completed, but given the trouble with patching all the sprung leaks
                // in this complicated and delicate filtering system, I'm going to leave this
                // here just from paranoia.
                //
                if (filters[key] === null) {
                    return true;
                }

                // Any filters still left in the passed-in object are filters to be added/changed.
                //
                that.gridFilters[key] =
                    angular.isString(filters[key]) ?
                        that.calculateTextSubstringFilter.call(that, key, filters[key]) :
                        angular.isNumber(filters[key]) ?
                            that.calculateNumberFilter.call(that, filters[key]) : filters[key];
            });

            // Map the names the grid uses for each column/field to what the API expects.
            //
            if (Object.keys(this.gridFilters).length) {
                this.gridFilters = this.mapFilterPropertiesToApiModel (this.gridFilters);
            }
            else {
                this.gridFilters = angular.copy(this.thisReport.grid.defaultFilters);
            }
        }

        public mapFilterPropertiesToApiModel ( filters: any ) : any {

            var that = this;

            var mappedFilters : any = { };

            Object.keys(filters).forEach( ( filterField: string )=> {

                if (filters[filterField] !== undefined) {

                    var mappedField = filterField;

                    // Accept a variety of mapping formats.  None, string, or object.
                    //
                    var mapConfig = that.propertiesToApiMap && that.propertiesToApiMap[mappedField];

                    if (mapConfig) {
                        if (angular.isString(mapConfig)) {
                            mappedField = mapConfig;
                        }
                        else if (angular.isObject(mapConfig)) {
                            mappedField = mapConfig.sort;
                        }
                    }

                    mappedFilters[mappedField] = filters[filterField];
                }
            });

            return mappedFilters;
        }

        private loadDataWithSortsAndFilters (
            sortColumns         : any[],
            filters             : any
        ) : ng.IPromise<void> {

            this.setSort (sortColumns);
            this.setFilters (filters);

            return this.loadData();
        }

        private toggleResultsLoading () : void {
            this.loading = ! this.loading;
        }

        private calculateLoadParams () : any {

            // Set sort and filter parameters.
            //
            var params = angular.extend(
                // Copy, otherwise gridSorts will be impregnated with the filter, below.
                //
                angular.copy(this.gridSorts || { }),
                { location_id: this.locationId }
            );

            if (Object.keys(this.gridFilters).length) {

                // Let's just build the simple flat, ANDed filter structure currently supported
                // by reports and save the full front-end implementation of that recursive complexity
                // for when we provide the ability to filter with complex logic.
                //
                params.filterss = {
                    conditions: {
                        and: {
                            attributes: angular.copy(this.gridFilters)
                        }
                    }
                }
            }

            return params;
        }

        public totalRecords = 0;

        private loadData () : ng.IPromise<void> {

            var that = this;

            // Tried angular-debounce -- didn't work the way we needed for
            // optimal UI.  Handrolled promise-based debounce would probably
            // be more elegant, but this does work.
            //
            if (this.debouncing) {
                this.loadRequested = true;
                return this.$q.when();
            }

            this.debouncing = true;

            this.toggleResultsLoading ();

            return this.thisReport.collection.model[
                this.thisReport.collection.loadMethod
                ]({
                promise : true,
                params  : this.calculateLoadParams()
            })
                .then(
                    ( collection: any ) => {

                        this.totalRecords = collection.pagination.total;

                        if (that.loadRequested) {
                            that.loadRequested = false;
                            that.debouncing = false;
                            that.loadData ();
                        }
                        else {
                            that.collection = collection;
                        }
                    }
                )
                .catch( ( ) => {
                    that.error = true;
                })
                .finally( ( ) => {
                    that.debouncing = false;
                    that.toggleResultsLoading ();
                });
        }

        public exportReportCsv(type: string) : void {

            if (type === 'this') {
                this.exportThisPageCsv();
            } else if (type === 'all') {
                this.exportAllPagesCsv();
            }
        }

        public exportThisPageCsv() : void {
            this.$timeout(() => {
                angular.element(document.getElementById('csvExportThisPage'))
                    .trigger('click');
            });
        }

        public exportAllPagesCsv() : void {
            this.$timeout(() => {
                angular.element(document.getElementById('csvExportAllPages'))
                    .trigger('click');
            });
        }

        public loadThisPageDataForExport ( ) : ng.IPromise<any> {
            return this.$q.when((<any>this.collection).data.map( ( row: any ) => {
                return row.data;
            }));
        }

        public loadAllDataForExport ( ) : ng.IPromise<any> {

            var that = this;

            // Reset to zero download state.
            //
            this.toggleResultsLoading ();
            this.initializeCurrentUploadData();
            that.downloadCsvStatus = 'IN_PROGRESS';
            this.$scope.timeRemaining = '';
            this.$scope.showTimeRemaining = true;

            // Setup toast.
            //
            this.downloadCsvDataToast = this.$dealerwareNotification;
            this.downloadCsvDataToast.fullToast ({
                templateUrl     : '/components/progress-toast/progress-toast-directive.html',
                hideDelay       : 0,
                scope           : angular.extend(this.$scope, {
                    progressData        : this.downloadCsvData,
                    statusText          : ( ) => this.statusText.call(this),
                    showTotalItemCount  : true
                }),
                preserveScope   : true
            });

            var defer = this.$q.defer();

            var exportSettings = this.thisReport.csvExport;

            var params: any = {
                location_id     : this.locationId
            };

            // Sorting.
            //
            if (exportSettings.allPages && exportSettings.allPages.sort) {
                if (exportSettings.allPages.sort.by) {
                    params.sort_by = exportSettings.allPages.sort.by;
                }
                if (exportSettings.allPages.sort.direction) {
                    params.sort_direction = exportSettings.allPages.sort.direction;
                }
            }

            // Default filters.
            //
            if (Object.keys(this.thisReport.grid.defaultFilters).length) {
                var filters = angular.copy(this.thisReport.grid.defaultFilters);

                for (var filter in filters) {
                    filters[filter] = this.gridFilters[filter];
                }

                params.filterss = {
                    conditions: {
                        and: {
                            attributes: filters
                        }
                    }
                };
            }

            this.downloadCsvData.stats.total.itemCount = this.totalRecords;
            var pages = Math.floor(this.totalRecords / 1000) + 1;
            var page = 0;

            let rows: any[] = [ ];

            var estimator = new this.dataUtils.remainingTimeEstimator();
            estimator.start(null, 5);

            // I even figured out some of this recipe myself!  Hooray for me!
            //
            Array.apply(null, Array(pages))
                .map( ( ) => {
                    return this.thisReport.collection.model[this.thisReport.collection.loadMethod]
                })
                .reduce( ( promiseAccumulator: any, promise: any ) => {

                    return promiseAccumulator.then( ( collection: any ) => {

                        if (collection && collection.data && collection.data.length) {

                            // Default CSV export function keeps the grid columns, rather than
                            // defining custom ones.
                            //
                            rows.push(...collection.data.map((row: any) => {
                                return row.data;
                            }));
                            this.downloadCsvData.stats.processed.itemCount += collection.data.length;

                            this.$scope.timeRemaining = estimator.mark(
                                this.downloadCsvData.stats.processed.itemCount,
                                this.downloadCsvData.stats.total.itemCount
                            );
                        }

                        return promise({
                            promise : true,
                            params  : (<any>Object).assign(params, { per_page: 1000, page: ++page })
                        });
                    });
                    // Starts promise code firing immediately.
                    //
                }, this.$q.when())
                .then( ( collection: any ) => {

                    // The final page of results.
                    //
                    rows.push(...collection.data.map( ( row: any ) => {
                        return row.data;
                    }));
                    this.downloadCsvData.stats.processed.itemCount += collection.data.length;

                    estimator.finish();
                    this.$scope.showTimeRemaining = false;

                    defer.resolve(rows);
                })
                .catch( ( response: any ) => {
                    defer.reject (response);
                    that.downloadCsvStatus = 'ERROR_UPLOAD';
                    that.error = true;
                })
                .finally( ( ) => {
                    if (this.downloadCsvDataToast) {
                        this.$timeout( ( ) => {
                            that.downloadCsvDataToast.$mdToast.cancel();
                            that.downloadCsvDataToast = null;
                        }, 6000);
                    }
                    that.downloadCsvStatus = 'FINISHED';
                    that.toggleResultsLoading ();
                });

            return defer.promise;
        }

        private resetToInitialData () : void {
            this.thisReport.$scope.$root.$broadcast('clearSortAndFilter');
        }

        private resetToInitialDataRetainingSorts () : void {
            this.thisReport.$scope.$root.$broadcast('clearFilter');
        }

        // Full grid reset, because essentially firing grid 'Clear ALL Filters' code, plus clearing
        // out the sorts, managed in the grid instantiator, i.e. this controller.
        //
        // This method is passed in an empty sorts array, plus calculated filters (also an empty array),
        // but the values are dropped on the floor since they're needlessly complicating.
        //
        private reloadInitialData () : void {
            this.loadDataWithSortsAndFilters ( [ ], { _deleteAll: true } );
        }

        //
        // Generic filter code.
        //
        public showFilterModal ( filterField: string ) : void {

            var that = this;

            this.$mdDialog.show({
                controller          : DialogController,
                templateUrl         : '/components/reports/filter-dialog.html',
                locals              : {
                    template        : that.filterControlData[filterField].template,
                    data            : that.filterControlData[filterField]
                },
                parent              : angular.element(document.body),
                multiple            : true,
                clickOutsideToClose : false,
                fullscreen          : false
            });

            function DialogController ($scope: any, $mdDialog: any, template: any, data: any) {

                $scope.template = template;
                $scope.data = data;

                $scope.close = function() {
                    $mdDialog.cancel();
                }
            }
        }

        public setAndExecuteFilter ( filterField: string,
                                     thisFilterData: any,
                                     calculateFilterFunction: any
        ) : ng.IPromise<void>  {

            var thisFilter  : any = { };

            if (thisFilterData) {
                thisFilter[filterField] = calculateFilterFunction.call(this, thisFilterData);
            }
            // This is a filter deletion.
            //
            else {
                thisFilter[filterField] = null;
            }

            return this.loadDataWithSortsAndFilters (null, thisFilter);
        }

        public setFilterControlData ( filterField: string, filterData: any ) : void {

            var that = this;

            var resetModalData = ( ) => {

                Object.keys(filterData.gridColumn.savedModalData || { }).forEach( ( key: string ) => {
                    filterData.gridColumn.modalData[key] = filterData.gridColumn.savedModalData[key];
                })
            };

            this.filterControlData[filterField] = angular.extend(filterData, {

                component: angular.extend(filterData.gridColumn.modalData, {

                    checkIsClearDisabled: function () {

                        var col = filterData.gridColumn || { };
                        var apiField = that.propertiesToApiMap[col.field] || col.field;

                        return that.gridFilters[apiField] === undefined;
                    },

                    checkIsApplyDisabled: function () {

                        var col = filterData.gridColumn || { };

                        // The filter modal can't open without some value, even if it's the default,
                        // populating it.  This case is for transition states before the modal has
                        // fully opened but digests are still running.
                        //
                        if (! col.modalData) {
                            return true;
                        }

                        var apiField = that.propertiesToApiMap[col.field] || col.field;
                        var modalFilterValues = filterData.calculateFilterFunction.call(this, col.modalData);

                        // Compare current values in the modal -- data values and comparison operator, if any,
                        // to gridFilters which contains the last filter params sent to the API.
                        //
                        var rv = Object
                            .keys(modalFilterValues || { })
                            .some( ( key: string ) => {
                                return modalFilterValues[key] !== (
                                    that.gridFilters[apiField] && that.gridFilters[apiField][key]
                                )
                            });

                        return ! rv;
                    },

                    onApply: function () {

                        that.setAndExecuteFilter.call (
                            that,
                            filterField,
                            filterData.gridColumn.modalData,
                            filterData.calculateFilterFunction
                        )
                            .then( ( ) => {
                                // For comparison, when cancelling or erroring, the current values in the modal
                                // vs. the values the last time it was opened, regardless of whether this filter
                                // has been sent to the API.
                                //
                                Object.keys(filterData.gridColumn.modalData).forEach( ( key: string ) => {
                                    filterData.gridColumn.savedModalData[key] = filterData.gridColumn.modalData[key];
                                });
                            })
                            .catch( ( ) => {
                                resetModalData();
                            });

                        that.$mdDialog.cancel();
                    },

                    onClear: function () {

                        delete filterData.gridColumn.modalData;

                        that.setAndExecuteFilter.call (
                            that,
                            filterField,
                            undefined,
                            filterData.calculateFilterFunction
                        )
                            .catch( ( ) => {
                                resetModalData();
                            });

                        that.$mdDialog.cancel();
                    },

                    onCancel: function () {
                        resetModalData();
                        that.$mdDialog.cancel();
                    }
                })
            });
        }

        public calculateTextSubstringFilter ( searchKey: string, searchTerm: string ) : any {

            // Text search could be either free-form text (use 'matches' key, because that's a
            // substring match), or a SELECT, in which case use 'eq' because that's a filter
            // requiring an exact text match.
            //
            for (var i = 0; i < this.gridColumnDefs.length; i++) {

                if ( searchKey === this.gridColumnDefs[i].field
                    && this.gridColumnDefs[i].filter
                    && this.gridColumnDefs[i].filter.type === this.uiGridConstants.filter.SELECT
                ) {
                    return { eq: searchTerm };
                }
            }

            return { matches: searchTerm };
        }

        public calculateNumberFilter ( searchTerm: number ) : any {
            return { in: searchTerm };
        }

        // Date Filter code.
        //
        public calculateDateFilter ( dateRangeData: any ) : any {

            if (dateRangeData.type === 'last') {
                var startDate = moment().add(-1 * dateRangeData.times, dateRangeData.interval).format('YYYY-MM-DD');
                var endDate   = moment().format('YYYY-MM-DD');
            }
            else if (dateRangeData.type === 'next') {
                var startDate = moment().format('YYYY-MM-DD');
                var endDate   = moment().add(dateRangeData.times, dateRangeData.interval).format('YYYY-MM-DD');
            }
            else if (dateRangeData.type === 'around') {
                var startDate = moment(dateRangeData.startDate).format('YYYY-MM-DD-HH-mm-ss');
                var endDate   = moment(dateRangeData.endDate).format('YYYY-MM-DD-HH-mm-ss');
            }

            return {
                gteq: startDate || dateRangeData.startDate,
                lteq: endDate   || dateRangeData.endDate
            };
        }

        public calculateDateInputFilter ( dateInputData: any ) : any {

            var date = dateInputData.monthYearDate;

            return {
                gteq: moment(date).startOf('month').format('YYYY-MM-DD-HH-mm-ss'),
                lteq: moment(date).endOf('month').format('YYYY-MM-DD-HH-mm-ss')
            };
        }

        // Numeric Filter code.
        //
        public calculateTimeFilter ( numericRangeData: any ) : any[] {

            // Yuck.
            //
            var getUtcRangeTime = ( hhmmString: string ) => {
                return moment()
                    .hour(parseInt(hhmmString.split(':')[0], 10))
                    .minute(parseInt(hhmmString.split(':')[1], 10))
                    .utc()
                    .format('HH:mm');
            };

            if (numericRangeData.type === 'between') {
                var dateFilter : any = {
                    gt: getUtcRangeTime(numericRangeData.startTime),
                    lt: getUtcRangeTime(numericRangeData.endTime)
                };
            }
            else if (numericRangeData.type === 'between_inclusive') {
                var dateFilter : any = {
                    gteq: getUtcRangeTime(numericRangeData.startTime),
                    lteq: getUtcRangeTime(numericRangeData.endTime)
                };
            }
            else {
                var dateFilter : any = { };
                dateFilter[String(numericRangeData.type)] = getUtcRangeTime(numericRangeData.startTime);
            }

            return dateFilter;
        }

        // Numeric Filter code.
        //
        public calculateNumericFilter ( numericRangeData: any ) : any[] {

            var choices = numericRangeData.startRangeChoices;

            var valueTransform = numericRangeData.valueTransform ||
                ( ( v: number ) => { return v; } );

            if (numericRangeData.type === 'between') {
                var numericFilter : any = {
                    gt: valueTransform (numericRangeData.startRange),
                    lt: valueTransform (numericRangeData.endRange)
                };
            }
            else if (numericRangeData.type === 'between_inclusive') {
                var numericFilter : any = {
                    gteq: valueTransform (numericRangeData.startRange),
                    lteq: valueTransform (numericRangeData.endRange)
                };
            }
            else if (numericRangeData.type === 'eq') {

                var choiceIndex = 0;
                choices.find( ( choice: any ) => {
                    if (choice.value === parseFloat(numericRangeData.startRange)) {
                        return true;
                    }

                    choiceIndex++;
                });

                if (numericRangeData.eqDirectionOver) {
                    var numericFilter : any = {
                        gteq: valueTransform (
                            choices[choiceIndex - 1 < 0 ? 0 : choiceIndex - 1].value
                        ),
                        lteq: valueTransform (choices[choiceIndex].value)
                    };
                }
                else {
                    var numericFilter : any = {
                        gteq: valueTransform (choices[choiceIndex].value),
                        lteq: valueTransform (
                            choices[
                                choiceIndex + 1 === choices.length ?
                                    choices.length - 1 : choiceIndex + 1
                                ].value
                        )
                    };
                }
            }
            else {
                var numericFilter : any = { };
                numericFilter[String(numericRangeData.type)] = valueTransform (
                    numericRangeData.startRange
                )
            }

            return numericFilter;
        }

        private resolveHiddenColumns () : void {

            this.thisReport.grid.columns.forEach( ( column: any ) => {
                if (typeof column.visibleCallback === 'function') {
                    column.visible = column.visibleCallback.call(this);
                }
            });
        }

        private resolveAbsentColumns () : void {

            this.thisReport.grid.columns = this.thisReport.grid.columns.filter( ( column: any ) => {
                if ( typeof column.presentCallback === 'function'
                    && ! column.presentCallback.call(this)
                ) {
                    return false;
                }

                return true;
            });
        }
    }

    getDealerwareWebComponentsModule().controller(
        'ReportsController', ReportsController
    );

}

